import { UIPageEnum } from '@/enums/ui.page.enum'
import type { RouteRecordRaw } from 'vue-router'
import { AuthLayout } from '@/layouts'

export const authRoutes: RouteRecordRaw = {
  path: UIPageEnum.AUHT_ROOT,
  name: UIPageEnum.AUTH_ROOT_NAME,
  component: AuthLayout,
  redirect: '/auth/login',
  children: [
    {
      path: '/auth/login',
      name: 'SigninPage',
      alias: ['/login', '/auth/login'],
      component: () => import('@/pages/auth/Signin.vue'),
      meta: {},
    },
    {
      path: '/auth/wx_login',
      name: 'WechatLoginPage',
      component: () => import('@/pages/auth/WechatSignin.vue'),
      meta: {},
    },
  ],
}
